// extracted by mini-css-extract-plugin
export default {"container":"styles_container__WwlX3","wrapper":"styles_wrapper__miyIk","main":"styles_main__vpEAL"};